import Vue from 'vue'
import Router from 'vue-router'
import authGuard from './authGuard'
import allRoutes from './allRoutes'

Vue.use(Router)

const router = new Router({
  routes: allRoutes
})
router.beforeEach(authGuard)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js